// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"6f46cc46","151":"b3a1c660","248":"143c9892","301":"02f0a03f","472":"7e54c966","482":"4182e59f","491":"7e54e8cb","566":"aa94b87f","626":"cc959b4e","776":"badcb4d6","884":"4feebb71","915":"c65c5d61"}[chunkId] + ".chunk.js";
};